import React from 'react';
import { useCoreKeyMetrics } from '../hooks';
import { TabPanel, Tabs } from 'tea-component';
import KeyMetricsTable from './KeyMetricsTable';
import CardCommon from '@op/components/CardCommon';
import { KeyMetricsChart } from './KeyMetricsChart';
import { ClassSpecial } from '@op/constants/common';
import { lineIcon, tableIcon } from '@op/constants/chart';
import chartEvent, {
  ChartEventInjectedProps,
} from '@op/pages/Detail/component/chartEvent';

import './index.scss';
import useLanguage from '@op/hooks/useLanguage';
import { keyMetricObj, keyMetricsArray } from '../constants';

function CoreKeyMetrics({
  chartType,
  setChartType,
  eventsDict,
  filter,
}: ChartEventInjectedProps) {
  const { loading, data, download } = useCoreKeyMetrics({ filter });
  const { formatMessage } = useLanguage();
  return (
    <CardCommon
      className="dbo-core-keymetrics-card"
      title={formatMessage('Weekly Tracking of Key Metrics')}
      operations={[lineIcon, tableIcon]}
      hasDownload
      defaultOperation={chartType}
      handleOperationsOnClick={(item: any) => setChartType?.(item.symbol!)}
      handleDownloadOnClick={() => download()}
    >
      <Tabs className={ClassSpecial.TAB_NONE} activeId={chartType}>
        <TabPanel id={'table'}>
          <KeyMetricsTable
            event={eventsDict}
            loading={loading}
            data={data}
          ></KeyMetricsTable>
        </TabPanel>
        <TabPanel id={'line'}>
          <KeyMetricsChart height={440} filter={filter}></KeyMetricsChart>
        </TabPanel>
      </Tabs>
    </CardCommon>
  );
}

const defaultMetricItem = keyMetricsArray[0];
export default chartEvent({
  key: 'WeeklyReportOverview',
  paramsList: {
    table: { metric: { key: 'metric', isArray: false }, time: 'xAxis' },
    line: { time: 'name' },
  },
  defaultChartType: 'table',
  props: {
    metric: defaultMetricItem.key,
  },
  fixedFilter: {
    channel: [
      'twitter',
      'tiktok',
      'instagram',
      'youtube', 
    ],
    channel_type: 'social',
    external_data_sources: ['-99999'],
    review_types: ['posts_text', 'posts_video', 'stream_titles'],
  },
  finalDealwithDetailParams: (params, { chartType, componentProps }) => {
    const { filter, defaultProps, extraConfig } = params;
    const { metric } = defaultProps || {};
    const {
      text: title,
      sortItem,
      filterKeys,
    } = keyMetricObj[metric] || defaultMetricItem;

    const fixedFilter = filterKeys.reduce((acc: any, cur: string) => {
      const value = componentProps?.defaultProps?.[cur];
      if (value) {
        return { ...acc, ...value };
      }

      return acc;
    }, {});

    let otherExtraConfig: any = {};

    if (chartType === 'table') {
      otherExtraConfig = {
        start_time: filter.start_time,
        end_time: filter.end_time,
        date_type: filter.date_type,
      };
    }
    return {
      ...params,
      title,
      filter: { ...filter, ...fixedFilter },
      extraConfig: { ...extraConfig, ...otherExtraConfig, sort_item: sortItem },
    };
  },
})(CoreKeyMetrics);
